<template>
  <div class="reservation-info-wrap">
    <div class="reservation-content">
      <div class="seek-desc-wrap">
        <p><span></span>症状描述</p>
        <div>{{ consultationInfo.descriptionInfo }}</div>
      </div>
      <div class="seek-img-list">
        <viewer
          v-if="
            this.consultationInfo.imageList &&
            this.consultationInfo.imageList.length > 0
          "
          class="seek-img-list"
          :images="this.consultationInfo.imageList"
        >
          <img
            v-for="(item, key) in consultationInfo.imageList"
            :src="item"
            :key="key"
            class="img"
          />
        </viewer>
      </div>
      <div class="seek-history-wrap">
        <p v-show="consultationInfo &&consultationInfo.historyCase&& consultationInfo.historyCase.length>0"><span></span>历史病历</p>

        <div class="seek-history-list">
          <div
            v-for="(item, index) in consultationInfo.historyCase"
            :key="index"
            class="collapse-item-wrap"
          >
            <div
              class="collapse-item"
              @click="collapseTag(index)"
              v-if="item.diagnosis"
            >
              <div class="arrow down"></div>
              <div class="title">
                <p>就诊时间：{{ item.time }}</p>
                <p>就诊科室：{{ item.department }}</p>
                <p>就诊医生：{{ item.doctorName }}</p>
                <p>诊断结果：{{ item.diagnosis.split(';')[0] }}</p>
              </div>
            </div>
            <div
              class="collapse-content"
              style="display: none"
              v-if="item.diagnosis"
            >
              <p>病历</p>
              <div>
                <div>
                  <span v-if="item.mainSuit">主诉：{{ item.mainSuit }}</span
                  ><span v-if="item.diagnosis">诊断：{{ item.diagnosis }}</span>
                </div>
                <div>
                  <span v-if="item.currentCase"
                    >现病史：{{ item.currentCase }}</span
                  ><span v-if="item.treatIdea"
                    >处置意见：{{ item.treatIdea }}</span
                  >
                </div>
                <div class="box-wrap">
                  <span v-if="item.recipe.length > 0">
                    <p>处方信息</p>
                    <p v-for="(recipe, ix) in item.recipe" :key="ix">
                      {{ recipe.drugName }}*{{ recipe.drugCount }}&nbsp;&nbsp;{{
                        recipe.specification
                      }}&nbsp;&nbsp;{{ recipe.usage }}&nbsp;&nbsp;{{
                        recipe.dosage
                      }}&nbsp;&nbsp;{{ recipe.frequency }}
                    </p>
                  </span>
                  <span v-if="item.Report && item.Report.length > 0">
                    <p>报告</p>
                    <div>
                      <div
                        v-for="(report, ix) in item.Report"
                        :key="ix"
                        class="tag-style"
                      >
                        {{ report.text }}
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  api
} from '@/services'

import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      consultationInfo: {
        'data': {}
      }

    }
  },
  methods: {
    collapseTag (index) { // 历史病历展开交互
      let domArr = document.getElementsByClassName('collapse-content')
      let arrowArr = document.getElementsByClassName('arrow')
      for (let i = 0; i < domArr.length; i++) {
        if (i == index) {
          if (domArr[i].style.display === 'inline-block') {
            domArr[i].style.display = 'none'
            arrowArr[i].className = 'arrow down'
          } else {
            domArr[i].style.display = 'inline-block'
            arrowArr[i].className = 'arrow up'
          }
        } else {
          domArr[i].style.display = 'none'
          arrowArr[i].className = 'arrow down'
        }
      }
    }
  },
  computed: {

    ...mapGetters({
      noGetReserveInfo: 'prvateConsultation/noGetReserveInfo',
      userInfo: 'auth/info'
    }),
    orderId () {
      return this.$store.state.prvateConsultation.orderId
    }
  },
  watch: {
    orderId: function (val) {
      if(this.userInfo.hospital.includes('曹妃甸')){
        this.consultationInfo = {}
        return
      }
      if (val) {
        api.adminReserveInfo({
          data: {
            params: {
              orderId: val
            }
          }
        })
          .then(res => {
            if (res.code === 0) {
              this.consultationInfo = res.data

              this.$store.commit('prvateConsultation/setXbkpObj', {
                xbkpUser: res.data.xbkp_user,
                xbkpUserName: res.data.xbkp_user_name
              })
            }
          })
      } else {
        this.consultationInfo = {}
      }
    }
  }
}
</script>

<style>
.reservation-info-wrap {
  width: 685px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  box-sizing: border-box;
}
.reservation-content {
  width: 678px;
  height: 100%;
  display: inline-block;
  padding: 13px 23px 0 11px;
}
.seek-desc-wrap,
.seek-history-wrap {
  display: inline-block;
  line-height: 9px;
  font-size: 9px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 12px;
}
.seek-desc-wrap > p,
.seek-history-wrap > p {
  height: 9px;
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.seek-desc-wrap > p > span,
.seek-history-wrap > p > span {
  width: 3px;
  height: 9px;
  background: #4aa5fe;
  margin-right: 4px;
  display: inline-block;
}
.seek-desc-wrap > div {
  line-height: 13.5px;
  text-indent: 2em;
}
.seek-img-list {
  min-width: 506px;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 21px;
}
.seek-img-list .img {
  width: 45px;
  height: 45px;
  margin-right: 12px;
  display: inline-block;
}
.seek-history-list {
  width: 550px;
  display: inline-block;
}
.collapse-item-wrap {
  width: 550px;
  display: inline-block;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.collapse-item {
  width: 549px;
  height: 22px;
  background: #ebebeb;
  padding-left: 7px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}
.collapse-item .arrow {
  width: 8px;
  height: 5px;
  margin-right: 15px;
  position: relative;
}
.collapse-item .arrow.down::before {
  content: '﹀';
  position: absolute;
  text-align: center;
}
.collapse-item .arrow.up::before {
  content: '︿';
  position: absolute;
  text-align: center;
}
.collapse-item .title {
  width: 549px;
  height: 22px;
  line-height: 22px;
  font-size: 9px;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 16px;
  box-sizing: border-box;
  overflow: hidden;
}
.collapse-item .title > p {
  margin-right: 16px;
  text-align: left;
  white-space: nowrap;
}
.collapse-content {
  width: 549px;
  padding: 8px 14px 1px 30px;
  background: #fff;
  font-size: 9px;
  line-height: 9px;
  border-left: 1px solid #ebebeb;
  border-right: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}
.collapse-content > p {
  margin-bottom: 6px;
}
.collapse-content > div {
  width: 100%;
  display: inline-block;
}
.collapse-content > div > div {
  margin-bottom: 6px;
}
.collapse-content > div > div span {
  width: 49.9%;
  display: inline-block;
  word-break: break-all;
  vertical-align: top;
}
.collapse-content .box-wrap {
  display: flex;
  justify-content: flex-start;
}
.collapse-content .box-wrap > span > p {
  margin-bottom: 6px;
}
.tag-style {
  display: inline-block;
  padding: 2px 3px;
  border: 1px solid #e8eaec;
  border-radius: 2px;
  background: #f7f7f7;
  color: #515a6e;
  font-size: 6px;
  margin-bottom: 6px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/reservation_info/index.vue